export default __webpack_public_path__ + "static/media/lottery-not-selected.0ad17c71.svg";